import type { WorkplaceAnalyticsFeatureFlagValue } from "@clipboard-health/flag-backend-main";
import { isNonEmptyArray } from "@clipboard-health/util-ts";

export function canAccessWorkplaceAnalytics(params: {
  flag: WorkplaceAnalyticsFeatureFlagValue;
  hasAdminPrivileges: boolean;
  hasCorporateAdminRole: boolean;
}): boolean {
  const { flag, hasAdminPrivileges, hasCorporateAdminRole } = params;
  return (
    flag.enabled &&
    isNonEmptyArray(flag.tables) &&
    (hasAdminPrivileges || (hasCorporateAdminRole && !flag.internalUseOnly))
  );
}
